module.exports = __webpack_public_path__ + "f6e72f45ea61a205f2cb816d5c3a3c43.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/poppins/Poppins-Regular.woff2
// module id = 1577
// module chunks = 0